// extracted by mini-css-extract-plugin
module.exports = {"two-stories-wrapper":"row2-m__two-stories-wrapper__1Qt2B","base":"row2-m__base__MYZM7"};